import { useState } from 'react';
import { useAppCookies } from '@app/providers/AppCookieProvider';
import { ToLogout } from '@app/navigation/ToLogout';

export const useApp = () => {
  const cookies = useAppCookies();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (open: boolean) => {
    setMenuOpen(open);
  };

  return {
    cookies,
    anchorEl,
    menuOpen,
    handleClose,
    logout: ToLogout,
    toggleDrawer,
  };
};
